module.exports = __webpack_public_path__ + "img/login_logo.346efc2f.png";